import React from 'react'
import { OptionProps } from './types'

/** @deprecated - Use Select.Item from `@chilipiper/design-system/src/new` instead */
export const Option = <ValueType extends unknown = string>({
  children,
}: OptionProps<ValueType>) => <>{children}</>
